export default "__VITE_ASSET__D$RsnZ$i__"